import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { grey } from "../../../theme/muiColors";
import { useSelector } from "react-redux";
import { formatDate } from "src/utils";
import { JobChatView } from "../JobChatView";
import { JobChatSummary } from "./JobChatListItem";

interface JobChatWrapperProps {
  chat: JobChatSummary;
  onBack: () => void;
}

export function JobChatWrapper({ chat, onBack }: JobChatWrapperProps) {
  const companyTimeZone = useSelector((state: any) => state.userState.company?.timeZone || "UTC");
  const title = chat.alias || `Job #${chat.jobId}`;
  const startDate = chat.startDate ? new Date(chat.startDate) : null;
  const endDate = chat.endDate ? new Date(chat.endDate) : null;
  const dateRange =
    startDate && endDate && !Number.isNaN(startDate.getTime()) && !Number.isNaN(endDate.getTime())
      ? `${formatDate(chat.startDate, companyTimeZone, "M/d/yyyy, h:mm a")} – ${formatDate(chat.endDate, companyTimeZone, "M/d/yyyy, h:mm a")}`
      : "";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 1.5,
          py: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          flexShrink: 0,
        }}
      >
        <IconButton size="small" onClick={onBack} aria-label="Back">
          <ArrowBackIcon sx={{ fontSize: 20 }} />
        </IconButton>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontWeight: 600, fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {title}
          </Typography>
          {dateRange && (
            <Tooltip title={`Times are shown in the company time zone (${companyTimeZone}).`} arrow>
              <Typography
                component="span"
                sx={{ mt: 0.2, fontSize: 10, color: "text.secondary", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block" }}
              >
                {dateRange}
              </Typography>
            </Tooltip>
          )}
        </Box>

        <Box
          role="status"
          aria-label={chat.isActive ? "Active job" : "Closed job"}
          title={chat.isActive ? "Active" : "Closed"}
          sx={{
            width: 9,
            height: 9,
            borderRadius: "50%",
            bgcolor: chat.isActive ? "#22a447" : grey[400],
            flexShrink: 0,
          }}
        />
      </Box>

      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <JobChatView
          jobEventUid={chat.jobEventUid}
          companyId={chat.companyId}
          status={chat.status}
          jobAlias={chat.alias}
          hideHeader
        />
      </Box>
    </Box>
  );
}
